import { useContext, useEffect, useState } from "react";
import { ISystem } from "../../types/system";
import { UserContext } from "../../context/user";
import { useBoolean } from "../../hooks/use-boolean";
import { AllSystemsService } from "../../services/systems";
import { enqueueSnackbar } from "notistack";
import { IBranch } from "../../types/branch";
import { AllBranchesService } from "../../services/branches";
import { useRouter } from "../../routes/hooks";

const useSelectSystem = () => {

    // hooks
    const loading = useBoolean(true);
    const router = useRouter();

    // context
    const { user } = useContext(UserContext);

    // states
    const [systems, setSystems] = useState<ISystem[]>([]);
    const [userSystems, setUserSystems] = useState<ISystem[]>([]);
    const [selectedSystem, setSelectedSystem] = useState<ISystem | null>(null);
    const [branches, setBranches] = useState<IBranch[]>([]);
    const [userBranches, setuserBranches] = useState<IBranch[]>([]);
    const [selectedBranch, setSelectedBranch] = useState<IBranch | null>(null);

    // functions
    const getSystems = async () => {

        loading.onTrue();

        await AllSystemsService('').then(resp => {
            setSystems(resp.data);


        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        await AllBranchesService().then(resp => {
            setBranches(resp.data);
        }).catch(error => {
            enqueueSnackbar(error?.response?.data?.message || 'Ocorreu um erro', {
                variant: 'error'
            });
        });

        loading.onFalse();

    }

    const checkBranches = () => {
        branches.find((branch: IBranch) => user?.systemBranch?.some((systemBranch) => systemBranch.branchId == branch.id) && setuserBranches(prev => [...prev, branch]));
    }

    const checkSystem = () => {
        systems.find((system: ISystem) => user?.systemBranch?.some((systemBranch) => systemBranch.systemId == system.id && systemBranch.branchId == selectedBranch?.id) && setUserSystems(prev => [...prev, system]));
    }

    const confirmSystem = () => {

        localStorage.setItem("branch", `${selectedBranch?.id}`);

        if (selectedSystem?.id == 1) {
            router.push('/users');
        } else {
            window.location.href = selectedSystem?.link + "?tokenJwt=" + localStorage.getItem("token") + "&branch=" + selectedBranch?.id;
        }

    }
    

    useEffect(() => {
        getSystems();
    }, []);

    useEffect(() => {
        if (branches.length > 0) {
            checkBranches();
        }
    }, [branches]);

    useEffect(() => {
        if (selectedBranch != null) {
            checkSystem();
        } else {
            setUserSystems([]);
        }
    }, [selectedBranch]);

    return {
        userSystems,
        selectedSystem,
        setSelectedSystem,
        userBranches,
        selectedBranch,
        setSelectedBranch,
        confirmSystem
    }

}

export default useSelectSystem;